/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 5/7/20
 * Copyright All Rights Reserved
 */
import React from 'react';

const mapItemsToOptions = items => items.map((item) => {
  const {
    id, name, value, disabled,
  } = item;
  return (
    <option key={id} value={value} disabled={disabled || false}>
      {name}
    </option>
  );
});

export default mapItemsToOptions;



// WEBPACK FOOTER //
// ./js/components/support/forms/SelectMenus/mapItemsToOptions/index.jsx